const RADIUS = 42;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const CircularProgress = ({
  progress,
  size = "lg",
  indeterminate = false,
}: {
  progress: number;
  /** "lg" = 128px (w-32), "md" = 112px (w-28) */
  size?: "lg" | "md";
  /**
   * Spinning arc with no percentage — for waits whose duration we can't
   * honestly predict (a frozen percentage is a broken promise).
   */
  indeterminate?: boolean;
}) => {
  const pct = Math.floor(progress);
  const sizeClass = size === "lg" ? "w-32 h-32" : "w-28 h-28";

  return (
    <div className={`relative ${sizeClass} mb-8`}>
      <svg
        className={`w-full h-full -rotate-90 ${indeterminate ? "animate-spin [animation-duration:1.4s]" : ""}`}
        viewBox="0 0 100 100"
      >
        {/* Track */}
        <circle
          cx="50"
          cy="50"
          r={RADIUS}
          fill="none"
          stroke="var(--fill-2)"
          strokeWidth="5"
        />
        {/* Progress */}
        <circle
          cx="50"
          cy="50"
          r={RADIUS}
          fill="none"
          stroke="var(--accent)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={`${CIRCUMFERENCE}`}
          strokeDashoffset={`${CIRCUMFERENCE * (indeterminate ? 0.75 : 1 - progress / 100)}`}
          className={indeterminate ? "" : "transition-all duration-150 ease-linear"}
          style={{
            filter: "drop-shadow(0 0 6px var(--accent-glow))",
          }}
        />
      </svg>
      {/* Percentage in center (hidden while indeterminate) */}
      {!indeterminate && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-2xl font-bold text-[var(--text-primary)] tabular-nums tracking-tight">
            {pct}
            <span className="text-sm font-semibold text-[var(--text-tertiary)]">
              %
            </span>
          </span>
        </div>
      )}
    </div>
  );
};

export default CircularProgress;
